<template>
  <footer>
    <div
      class="container d-flex justify-content-between align-items-center flex-wrap"
    >
      <!-- Impressum -->
      <div>
       
        <a href="/impressum" class="text-white text-decoration-none">Impressum</a>
      </div>

      <!-- Contact Us -->
      <div>
        
        <p>
          <i class="fas fa-phone-alt me-2"></i>
          Phone: <a href="tel:+393806852464" class="text-white" target="_blank">0039 3806852464</a>
        </p>
        <p>
          <i class="fab fa-whatsapp me-2"></i>
          WhatsApp: <a href="https://wa.me/393806852464" target="_blank" class="text-white">0039 3806852464</a>
        </p>
        <p>
          <i class="fab fa-tiktok me-2"></i>
          Tiktok: <a href="https://www.tiktok.com/@poorent.it?_t=8sWKYixrTRG"  target="_blank" class="text-white">Poorent.it</a>
        </p>
      </div>

      <!-- Copyright -->
      <p class="mb-0">&copy; {{ new Date().getFullYear() }} Poorent. All Rights Reserved.</p>
    </div>
  
  </footer>
</template>

<script>
export default {
  name: "FooterSection",
};
</script>
